// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"558":"6ec58623","685":"da19c3e8"}[chunkId] + ".chunk.css";
};